export default __webpack_public_path__ + "assets/images/0edbe7bc8e5eb33338c6a8d813660cb0.png";